
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"9","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.234 2.742H7.43a1.166 1.166 0 00-.25-.562.616.616 0 00-.5-.227c-.558 0-.925.453-1.102 1.36-.172.9-.258 2.97-.258 6.21 0 2.688-.247 4.82-.742 6.399-.49 1.578-1.357 2.367-2.601 2.367-.25 0-.47-.02-.657-.062a2.172 2.172 0 01-.547-.204l.102-1.539h.734c.068.25.167.456.297.618.136.161.326.242.57.242.547 0 .891-.568 1.032-1.703.14-1.13.21-2.782.21-4.954 0-3.385.256-5.851.766-7.398C5 1.742 5.891.97 7.156.97c.183 0 .383.026.602.078.224.047.414.107.57.18l-.094 1.515z","fill":"currentColor"}})])
          )
        }
      }
    